module.exports = __webpack_public_path__ + "img/elbrug-3.bb43ecaf.jpg";